import { useState, useEffect } from 'react';
import { getUserApprovalFlows, getApprovalFlowDetail } from '../../services/approvalFlowService';

// İznin onay akışı adımları (kartta geçmişten sonraki "Bekliyor/Sırada" adımları ve geçmişi olmayan eski izinlerin
// türetilmiş adımları için). Sabitlenmiş izinde (spec 2026-11-01 §4.4) izin O akışla biter → akış kimliğiyle; işaretsiz
// eski izinde kişinin BUGÜNKÜ akışı. Oturum boyu modül düzeyinde önbellek (anahtar akış ya da kişi); başarısız okuma
// önbelleğe yazılmaz. Zincir LeaveDetailPage ile aynı.
const cache = new Map();

export function resetLeaveFlowStepsCache() {
  cache.clear();
}

async function loadSteps(userId, pin) {
  let flowId;
  if (pin?.pinned) {
    flowId = pin.flowId || null;
  } else {
    const flowsRes = await getUserApprovalFlows(userId);
    if (!flowsRes?.data?.status) throw new Error('flows');
    flowId = (flowsRes.data.data || []).find((f) => f.flowType === 'leave')?.approvalFlowId || null;
  }
  if (!flowId) return [];
  const detail = await getApprovalFlowDetail(flowId);
  if (!detail?.data?.status) throw new Error('flow');
  return (detail.data.data?.steps || []).slice().sort((a, b) => a.stepOrder - b.stepOrder);
}

// pin: { pinned, flowId } — iznin approvalFlowPinned / approvalFlowId alanları (verilmezse bugünkü akış).
export default function useLeaveFlowSteps(userId, enabled, pin) {
  const [state, setState] = useState(() => ({ steps: [], loading: !!(enabled && userId) }));
  const pinned = !!pin?.pinned;
  const pinnedFlowId = pin?.flowId || null;

  useEffect(() => {
    if (!enabled || !userId) {
      setState({ steps: [], loading: false });
      return undefined;
    }
    let alive = true;
    const key = pinned ? `flow:${pinnedFlowId || 'none'}` : `user:${userId}`;
    if (!cache.has(key)) {
      const pending = loadSteps(userId, { pinned, flowId: pinnedFlowId });
      cache.set(key, pending);
      pending.catch(() => cache.delete(key));
    }
    setState((s) => ({ steps: s.steps, loading: true }));
    cache.get(key)
      .then((steps) => { if (alive) setState({ steps, loading: false }); })
      .catch(() => { if (alive) setState({ steps: [], loading: false }); });
    return () => { alive = false; };
  }, [userId, enabled, pinned, pinnedFlowId]);

  return state;
}
